import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { ProposalRequest } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { ProposalRequestService } from 'src/app/services/proposal-request.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-proposal-requests-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './proposal-requests-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ProposalRequestsGridComponent
  extends BaseGridComponent
  implements OnInit
{
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private ProposalRequestService: ProposalRequestService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'ProposalRequest';
    this.rowModelType = 'serverSide';

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.ProposalRequestService.getProposalRequests(queryObject),
          this.ProposalRequestService.getProposalRequestCount(countQueryObject)
        ]).subscribe({
          next: ([ProposalRequests, proposalRequestCount]) => {
            const successObject: {
              rowData: ProposalRequest[];
              rowCount: number;
            } = {
              rowData: ProposalRequests,
              rowCount: proposalRequestCount
            };

            params.success(successObject);
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
